// 支付方式图标
import iconBank from '@/assets/pay-icons/bank.png';
import iconWechat from '@/assets/pay-icons/wechat.png';
import iconAlipay from '@/assets/pay-icons/alipay.png';
import iconQQ from '@/assets/pay-icons/qq.png';
import iconDigital from '@/assets/pay-icons/digital-rmb.png';
import iconC from '@/assets/pay-icons/c.png';
import iconUsdt from '@/assets/pay-icons/usdt.png';
import iconUnionPayT from '@/assets/pay-icons/union-pay-t.png';
import iconUnionPay from '@/assets/pay-icons/union-pay.png';
import iconWechatT from '@/assets/pay-icons/wechat-t.png';
import iconAlipayT from '@/assets/pay-icons/alipay-t.png';
import iconLogoC from '@/assets/counter/logo-c.png';
import iconWallet from '@/assets/pay-icons/wallet.png';

/**
 * 支付方式信息
 */
export const payTypeInfos = {
  1: {
    name: '银行卡',
    img: iconBank,
  }, // JSCK
  2: {
    name: '微信',
    img: iconWechat,
  }, // WXCK_MATCH
  3: {
    name: '支付宝',
    img: iconAlipay,
  }, // ZFBCK_MATCH
  4: {
    name: 'QQ',
    img: iconQQ,
  }, // QQPAY_CK_MATCH
  5: {
    name: '数字人民币',
    img: iconDigital,
  }, // ECYN_CK_MATCH
  6: {
    name: 'C币',
    img: iconC,
  },
  7: {
    name: 'USDT',
    img: iconUsdt,
  },
  8: {
    name: '云闪付',
    img: iconUnionPay,
  },
  101: {
    name: '云闪付转卡',
    img: iconUnionPayT,
  }, // YSFCK_BANK
  102: {
    name: '微信转卡',
    img: iconWechatT,
  }, // WXCK_BANK
  103: {
    name: '支付宝转卡',
    img: iconAlipayT,
  }, // ZFBCK_BANK
  105: {
    name: '支付宝',
    img: iconAlipay,
  }, // ZFBCK_CORNER
  106: {
    name: '银行卡',
    img: iconBank,
  }, // BANKCK_CORNER
  107: {
    name: '微信',
    img: iconWechat,
  }, // WECHATCK_CORNER
  108: {
    name: 'QQ',
    img: iconQQ,
  }, // QQCK_CORNER
  109: {
    name: '数字人民币',
    img: iconDigital,
  }, // ECNYCK_CORNER
  110: {
    name: '支付宝转卡',
    img: iconAlipayT,
  }, // ZFBCK_BANK_CORNER
  111: {
    name: '微信转卡',
    img: iconWechatT,
  }, // WXCK_BANK_CORNER
  112: {
    name: '云闪付转卡',
    img: iconUnionPayT,
  }, // YSFCK_BANK_CORNER
  113: {
    name: '支付宝促销',
    img: iconAlipay,
  },
};

/** payTypeCode 精确匹配 */
const payTypeCodeIconMap = {
  JSCK: iconBank,
  JSQK: iconBank,
  BANKCK_CORNER: iconBank,
  BANKQK_CORNER: iconBank,
  // USDT: iconUsdt,
  '68CCK': iconC,
  '68CQK': iconC,
  '68C_WALLET': iconLogoC,
  DZQB: iconWallet,
  SZRMBCK: iconDigital,
  ZFBCK_BANK: iconAlipayT,
  ZFBCK_BANK_CORNER: iconAlipayT,
  WXCK_BANK: iconWechatT,
  WXCK_BANK_CORNER: iconWechatT,
  YSFCK_BANK: iconUnionPayT,
  YSFCK_BANK_CORNER: iconUnionPayT,
  ALIPAY_JOB: iconAlipay,
};

/** payTypeCode 模糊匹配（按顺序，先转卡后普通） */
const payTypeCodeIconRules = [
  [/ZFB.*BANK/, iconAlipayT],
  [/WX.*BANK|WECHAT.*BANK/, iconWechatT],
  [/YSF.*BANK/, iconUnionPayT],
  [/^ZFB|ZFBQK/, iconAlipay],
  [/^WX|WXQK|WECHAT/, iconWechat],
  [/^YSF/, iconUnionPay],
  [/^QQ|QQQK/, iconQQ],
  [/ECNY|ECYN|SZRMB/, iconDigital],
  [/^JS|BANKCK|BANKQK/, iconBank],
  [/68C/, iconC],
];

/**
 * 存取款通道图标：优先本地 pay-icons，无匹配再用接口 url
 */
export const resolvePayMethodIconUrl = (payTypeCode, remoteUrl = '') => {
  const code = String(payTypeCode || '');
  if (!code) {
    return remoteUrl || '';
  }

  if (payTypeCodeIconMap[code]) {
    return payTypeCodeIconMap[code];
  }

  const matched = payTypeCodeIconRules.find(([pattern]) => pattern.test(code));
  if (matched) {
    return matched[1];
  }

  return remoteUrl || '';
};

// 粘贴文本
let pasteText = '';

/**
 * 粘贴文本 读写
 */
export const pasteTextRC = value => {
  if (value) {
    pasteText = value;
  }
  return pasteText;
};
